import Vue from "vue";
import NetworkManager from "../../../network/network-manager";
import Parser from "../network/parser.js";

export default {
  async loadContactUsPaginated(context, payload) {
    await NetworkManager.post(
      context,
      `contact-us/find-all-paginated-and-filtered`,
      payload,
      "PaginationResponse",
      "setPaginatedContactUs",
      Parser
    );
  },
  async countContactUsPaginated(context, payload) {
    await NetworkManager.post(
      context,
      `contact-us/find-all-paginated-and-filtered`,
      payload,
      "PaginationResponse",
      "setCount",
      Parser
    );
  },
  async loadContactUsColumns(context) {
    await NetworkManager.get(
      context,
      `contact-us-column-name`,
      "ContactUsColumn",
      "setContactUsColumn",
      Parser
    );
  },
    async loadContactUsTypeColumns(context , payload) {
    await NetworkManager.get(
      context,
      `/contact-us-type-column/type/${payload}`,
      "ContactUsTypeColumn",
      "setContactUsTypeColumn",
      Parser
    );
  },
  async loadContactUsConfig(context) {
    await NetworkManager.get(
      context,
      `contact-us-config`,
      "ContactUsConfig",
      "setContactUsConfig",
      Parser
    );
  },
  async editContactUsColumnConfig(context, payload) {
    await NetworkManager.put(
      context,
      `contact-us-config/${payload.id}`,
      payload,
      "ContactUsConfig",
      null,
      Parser
    );
  },
  async downloadContactUsExcel(context , payload) {
    return await NetworkManager.download(`/contact-us/export/${payload}`);
  },
  async createContactUsColumnConfig(context, payload) {
    await NetworkManager.post(
      context,
      `contact-us-config`,
      payload,
      "ContactUsConfig",
      "setContactUsConfig",
      Parser
    );
  },
  async deleteContactUs(context, payload) {
    await NetworkManager.put(
      context,
      `contact-us/marked-as-deleted/${payload.id}`,
      payload,
      null,
      "deleteContactUs",
      Parser
    );
  },
  async editCareerColumnName(context, payload) {
    await NetworkManager.put(
      context,
      `contact-us-column-name/${payload.id}`,
      payload,
      "ContactUsColumn",
      null,
      Parser
    );
  },
  async contactUsColumnsChangeStatus(context, payload) {
    await NetworkManager.put(
      context,
      `/contact-us-type-column/type/${payload.typeId}/active-status`,
      payload.contactsActive,
      "ContactUsColumn",
      null,
      Parser
    );
  },
  async loadTypes(context) {
     await NetworkManager.get(
      context,
      `contact-us-type`,
      "Type",
      "setTypes",
      Parser
    );
  },

  async loadTickets(context) {
    await NetworkManager.get(
      context,
      `ticket`,
      null,
      null,
      Parser,
      null,
      Vue.prototype.$ticketAxios
    );
  },
 
};
